<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
     <!-- BOC:[error] -->
     <AError
        v-if="api.isError"
        :api="api"
        :callbackReset="() => (api.isError = false)"
      ></AError>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-card-title>Create New Child User</v-card-title>
     
      <div class="d-flex align-center justify-space-around">
       
        <div class="form-content text-center">
          <v-form ref="formName" v-model="valid" lazy-validation>
            <div class="text-center pt-3">
              <v-text-field
                v-model="name"
                block
                label="Full Name (as in NRIC / Passport)"
                outlined
                clearable
                :rules="nameRules"
              ></v-text-field>
            </div>
            <div v-if="selectedType == 'child'" class="text-center pt-3">
              <SelectField
                :value="schoolYear"
                :field="selectSchoolYearField"
                @input="schoolYear = $event"
                label="School Year"
              ></SelectField>
            </div>
            <div class="text-center pt-3">
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Date of Birth"
                    readonly
                    outlined
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    :rules="dobRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  color="primary"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substring(0, 10)
                  "
                  min="1950-01-01"
                  @click:date="$refs.menu.save(date)"
                  @input="menu2 = false"
                >
                </v-date-picker>
              </v-menu>
            </div>
            <v-card-actions @click="show = !show">
              <div class="text-caption">
                The following information is optional but must be provided in order to qualify for PAJSK. Currently only Penang state will give PAJSK for Math challenge in 2025.
              </div>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>{{
                  show ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>
                <div class="text-center pt-3">
                  <SelectField
                    :value="gender"
                    :field="selectGenderField"
                    @input="gender = $event"
                    label="Gender"
                  ></SelectField>
                </div>
                <div v-if="gender == 'other'" class="text-center pt-3">
                  <TextField
                    :value="originalGender"
                    label="Other Gender"
                    type="text"
                    @input="originalGender = $event"
                  ></TextField>
                </div>
                <div class="text-center pt-3">
                  <SelectField
                    :value="race"
                    :field="selectRaceField"
                    @input="race = $event"
                    label="Race"
                  ></SelectField>
                </div>
                <div v-if="race == 'other'" class="text-center pt-3">
                  <TextField
                    :value="originalRace"
                    label="Other Race"
                    type="text"
                    @input="originalRace = $event"
                  ></TextField>
                </div>
                <div class="text-center pt-3">
                  <TextField
                    :value="moeNumber"
                    label="NRIC/Passport Number"
                    :rules="moeRules"
                    type="text"
                    @input="moeNumber = $event"
                  ></TextField>
                </div>
                <div class="text-center pt-3">
                  <TextField
                    :value="email"
                    label="Email Address"
                    :rules="emailRules"
                    type="text"
                    hint="Recommend to use MOE Email Address"
                    @input="email = $event"
                  ></TextField>
                </div>
                <div
                  class="text-center pt-3"
                >
                  <TextField
                    :value="mainInstitution"
                    label="School Name"
                    type="text"
                    @input="mainInstitution = $event"
                  ></TextField>
                </div>
                <div
                  class="text-center pt-3"
                >
                  <TextField
                    :value="mainClassroom"
                    label="Classroom Name"
                    type="text"
                    @input="mainClassroom = $event"
                  ></TextField>
                </div>
                <div class="text-center pt-3">
                  <SelectField
                    :value="selectedState"
                    :field="selectStateField"
                    @input="selectedState = $event"
                    label="State"
                  ></SelectField>
                </div>
              </div>
            </v-expand-transition>
            <div class="text-center pt-1">
              <v-btn width="75%" :loading="api.isLoading" rounded color="primary" dark @click="submit()">
                Submit
              </v-btn>
            </div>
            <div class="text-center pt-2">
              <v-btn
                width="75%"
                rounded
                outlined
                color="primary"
                dark
                @click="$router.go(-1)"
              >
                Cancel
              </v-btn>
            </div>
          </v-form>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import datasetSchoolYears from "@/datasets/schoolYear";
import datasetMonths from "@/datasets/month";
import datasetYears from "@/datasets/year";
import SelectField from "@/components/Form/SelectField.vue";
import moment from 'moment';
import datasetGender from '@/datasets/gender'
import datasetRace from '@/datasets/race'
import TextField from "@/components/Form/TextField.vue";
export default {
  components: {
    SelectField,
    TextField
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
     //BOC:[apiState]
    apiState: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    selectedState: null,
    states: [],
    show: true,
    selectStateField: {
      defaultValue: null,
      name: "State",
      options: [],
      optionText: "text",
      optionValue: "value",
    },
    selectGenderField: {
      defaultValue: null,
      name: "Gender",
      options: datasetGender,
      optionText: "name",
      optionValue: "value",
    },
    selectRaceField: {
      defaultValue: null,
      name: "Race",
      options: datasetRace,
      optionText: "name",
      optionValue: "value",
    },
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    menu2: false,
    // date: moment().format("YYYY-MM-DD"),
    date: null,
    menu: false,
    valid:true,
    name: null,
    email: null,
    gender: null,
    race: null,
    mainInstitution: null,
    mainClassroom: null,
    originalRace: null,
    originalGender: null,
    moeNumber: null,
    nameRules:[],
    dobRules: [],
    raceRules: [],
    emailRules: [],
    genderRules: [],
    moeRules: [],
    step: 1,
     //BOC:[api]
     api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    userTypes: [
      {
        id: 1,
        name: "Adult",
        value: "adult",
      },
      {
        id: 2,
        name: "Child",
        value: "child",
      },
    ],
    selectedType: 'child',
    selectSchoolYearField: {
      defaultValue: 1,
      name: "School Year",
      options: datasetSchoolYears,
      optionText: "name",
      optionValue: "id",
    },
    schoolYear:1,
    selectMonthField: {
      defaultValue: 1,
      name: "Month",
      options: datasetMonths,
      optionText: "name",
      optionValue: "id",
    },
    month:3,

    selectYearField: {
      defaultValue: moment().format('YYYY').toString(),
      name: "Year",
      options: datasetYears,
      optionText: "",
      optionValue: "",
    },
    year:moment().format('YYYY').toString(),
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs.push({
      text: "Dashboard",
      to: { name: "PageFamilyDashboard" },
      exact: true,
    });

    this.breadcrumbs.push({
      text: "New Child User",
      to: { name: "PageFamilyUserAdd" },
      exact: true,
    });

    //EOC
    this.api.url =
      this.$api.servers.sso +
      "/api/v2/" +
      this.$_getLocale() +
      "/backend/user/add";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.$router.push({ name: "PageFamilyDashboard" });
    };
//BOC: [apiState]
    this.apiState.method = "GET";
    this.apiState.url = `${this.$api.servers.sso}/api/v1/en/data/state`;
    this.apiState.callbackReset = () => {
      this.apiState.isLoading = true;
      this.apiState.isError = false;
    };
    this.apiState.callbackError = (e) => {
      this.apiState.isLoading = false;
      this.apiState.isError = true;
      this.apiState.error = e;
    };
    this.apiState.callbackSuccess = (resp) => {
      this.states = [{text:'Select State',value:null}];
      resp.forEach((s)=>{
        this.states.push({text:s.name,value:s.value});
      })
      this.selectStateField.options = this.states
    };
    //EOC
  },
  mounted() {
     this.$api.fetch(this.apiState);
  },
  watch:{
    name: function () {
      this.nameRules = [];
    },
  },
  methods: {
    close() {
      this.$router.push({ name: "PageFamilyDashboard" });
    },
    submit() {
      this.nameRules = [
      (v) => !!v || "Name is required",
      ];
      this.dobRules = [(v) => !!v || "Date of Birth is required"];
      let self = this;
      setTimeout(function () {
        if (self.$refs.formName.validate()) {
          self.api.params = {
            name: self.name,
            month : self.selectedType == 'child'? self.month : null,
            schoolYear:self.selectedType == 'child'? self.schoolYear : null,
            year: self.selectedType == 'child'? self.year : null,
            type: self.selectedType,
            dateOfBirth: self.date,
            race:self.race,
            gender:self.gender,
            originalGender: self.originalGender,
            originalRace: self.originalRace,
            moeNumber:self.moeNumber,
            email:self.email,
            mainClassroom: self.mainClassroom,
            mainInstitution: self.mainInstitution,
            state: self.selectedState,
          };
          self.$api.fetch(self.api);
        } else {
          self.api.callbackError("Please check the form.");
        }
      });
    },
    selectUserType(item){
      this.selectedType = item.value
      this.step++;
    }
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 300px !important;
}
</style>